export const SwInputParseOnlyDigits = (value: string) =>
  value.replace(/\D/g, '');
